export const Regexes = {
  atLeastOneUpperCaseLetter: /(?=.*?[A-Z])/,
  atLeastOneLowerCaseLetter: /(?=.*?[a-z])/,
  atLeastOneDigit: /(?=.*?[0-9])/,
  atLeastOneSpecialCharacter: /(?=.*?[#?!@$%^&*-])/,
  isValidEmail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  zipCode: /^\d+$/,
  regionCode: /^[A-Z]{2}(-[A-Z]{2})?$/,
};
